import {
  EntityTypeEnum,
  TemplateRuleCheckTargetEnum,
} from '../../../../shared/models';

export const templateRuleCheckTargetDefinition: Record<
  TemplateRuleCheckTargetEnum,
  { label: string; entityType: EntityTypeEnum }
> = {
  [TemplateRuleCheckTargetEnum.company_main]: {
    label: 'Main company',
    entityType: EntityTypeEnum.company,
  },
  [TemplateRuleCheckTargetEnum.company_affiliated]: {
    label: 'Affiliated companies',
    entityType: EntityTypeEnum.company,
  },
  [TemplateRuleCheckTargetEnum.individual_any]: {
    label: 'Individual',
    entityType: EntityTypeEnum.individual,
  },
};
